import { talks } from "@/mocks/gossip";
import SectionHead from "./SectionHead";

export default function TodayTalk() {
  return (
    <section id="talk" className="mx-auto max-w-[1400px] scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
      <SectionHead
        kicker="DAILY DEBATES"
        title="今日热议"
        note="全网讨论度最高的深扒话题，持续更新中"
      />
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {talks.map((t) => (
          <article key={t.idx} className="group flex items-start gap-4 rounded-lg border border-foreground-200/60 bg-background-50 p-4 transition-colors hover:border-primary-300">
            <span className="font-heading pt-0.5 text-3xl font-black text-secondary-300 transition-colors group-hover:text-primary-500">
              {t.idx}
            </span>
            <div className="flex-1">
              <span className={"inline-block rounded px-2 py-0.5 text-[11px] font-bold " + (t.idx === "01" ? "bg-primary-100 text-primary-800" : "bg-secondary-100 text-secondary-900")}>
                {t.cat}
              </span>
              <a href="#archive" className="font-heading mt-2 block text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                {t.title}
              </a>
              <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1"><i className="ri-eye-line" />{t.read}</span>
                <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line" />{t.comment}</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}